import { createContext, useContext, useState } from "react";
import styles from "./AlertProvider.module.css";

interface Alert {
  id: number;
  message: string;
}

interface AlertContextType {
  showAlert: (e: string) => void;
}

const AlertContext = createContext<AlertContextType | undefined>(undefined);

export const AlertProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [alerts, setAlerts] = useState<Alert[]>([]);

  const showAlert = (message: string) => {
    const id = Date.now() + Math.random(); // unique id
    const newAlert: Alert = { id, message };
    setAlerts((prev) => [...prev, newAlert]);

    setTimeout(() => {
      setAlerts((prev) => prev.filter((alert) => alert.id !== id));
    }, 5000);
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      <div className={styles.container}>
        {alerts.map((alert) => (
          <div className={styles.alertContainer}>
            <div key={alert.id} className={styles.alert}>
              {alert.message}
            </div>
          </div>
        ))}
      </div>
      {children}
    </AlertContext.Provider>
  );
};

export const useAlert = (): AlertContextType => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error("useAlert must be used within an AlertProvider");
  }
  return context;
};
